import {useContext, useState} from "react";
import {AccountContext} from "../AccountContext";
import "./Adjustment.css";
import UpdateTransactionState from "./UpdateTransactionState";

const Adjustment = (props) => {
    const {accountId, transactionService, setError} = useContext(AccountContext);
    const {originalTransactionId, clearModal, originalAmount} = props;
    const [sendingAdjustment, setSendingAdjustment] = useState(false as boolean);
    const [amount, setAmount] = useState(Math.abs(originalAmount));
    const [direction, setDirection] = useState("Credit");

    const onAdjustmentClicked = async () => {
        try {
            setSendingAdjustment(true);
            if (direction === "Credit") {
                await transactionService.creditAdjustment(accountId, originalTransactionId, amount);
            }
            if (direction === "Debit") {
                await transactionService.debitAdjustment(accountId, originalTransactionId, amount);
            }
            setSendingAdjustment(false);
            clearModal();
        } catch (error) {
            setError({source: 'Adjustment', ...error});
        }
    };

    const onUpdateStateClicked = async () => {
        try {
            clearModal();
        } catch (error) {
            setError({source: 'StateChange', ...error});
        }
    };

    return (
        <div className="ui card">
            <div className="custom-card-header">
                Adjust Transaction
            </div>
            <div className="grey subHeader">{originalTransactionId}</div><div className="content">
                <div className="ui form">
                <div className="ui actions">
                        <UpdateTransactionState 
                        transactionId={originalTransactionId}
                        transactionStateUpdated={onUpdateStateClicked}/>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="ui form">
                    <div className="field">
                        <label>Amount</label>
                        <div className="ui labeled input">
                            <div className="ui label">
                                £
                            </div>
                            <input value={amount} type="number" placeholder="Amount" step=".01" disabled={sendingAdjustment} onChange={e => setAmount(parseFloat(e.target.value))} />
                        </div>
                    </div>
                    <div className="field">
                        <div className="ui labeled input">
                            <div className="ui label">Credit or Debit</div>
                            <select onChange={e => setDirection(e.target.value)}>
                                <option value="Credit">Credit</option>
                                <option value="Debit">Debit</option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>

            <button className={`ui primary button ${sendingAdjustment && 'loading'}`} type="submit" onClick={() => onAdjustmentClicked()}>Submit</button>
        </div>
    );
}
export default Adjustment;